module.exports = __webpack_public_path__ + "static/media/5.d58e2ca3.jpg";